module.exports = __webpack_public_path__ + "static/media/equilibre_jaune.4f804bff.svg";